import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-releases-approvers.common.limit-reached-error.title',
		defaultMessage: "You can't add any more approvers",
		description: 'Title of the add approvers link dialog in disabled state',
	},
	description: {
		id: 'software-releases-approvers.common.limit-reached-error.description',
		defaultMessage:
			"You've reached the maximum limit of 100 approvers for this version - whoa! Please remove some approvers if you want to add more.",
		description: 'Description of the add approvers dialog in disabled state',
	},
});
